import React from "react";

export default ({ color = "#2D8EFF" }) => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M4.0001 7.77997L1.2201 4.99997L0.273438 5.93997L4.0001 9.66664L12.0001 1.66664L11.0601 0.726639L4.0001 7.77997Z" />
    </svg>
);



// WEBPACK FOOTER //
// ./src/icons/checkmark.js